// extracted by mini-css-extract-plugin
module.exports = {"labels":"_0fce717cdb--labels--uaMPj","promo":"_0fce717cdb--promo--aoHW5"};